/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Process_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Video export process failed with error: {error}" |
*
* @param {Video_Export_Process_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_process_failed_toast = /** @type {((inputs: Video_Export_Process_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Process_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le processus d'exportation video a echoue : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Videoexportvorgang ist mit folgendem Fehler fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il processo di esportazione video non è riuscito con errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Процесс экспорта видео завершился с ошибкой: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El proceso de exportación de video falló con el error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频导出过程失败，错误代码：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオのエクスポート プロセスがエラーにより失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रक्रिया त्रुटि ${i?.error} के साथ विफल रही।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O processo de exportação de vídeo falhou com o erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Video export process failed with error: ${i?.error}`)
});